import { $el } from 'src/scripts/utils/utils'
import { ModalComponent } from '../../components/modal/modal'
import { type Nullable } from '../../types/common'

export class PopupCookie extends ModalComponent {
  mountComponent(): void {
    if (this.isEditor) {
      this.editor.on('BLOCK_SELECT', this._handleBlockSelect)
      this.editor.on('BLOCK_DESELECT', this._handleBlockDeselect)
      return
    }

    window.Shopify.loadFeatures?.(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          throw error
        }

        const userCanBeTracked =
          window.Shopify.customerPrivacy?.userCanBeTracked()
        const userTrackingConsent =
          window.Shopify.customerPrivacy?.getTrackingConsent()

        if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.show()
        }
      },
    )
  }

  _handleBlockSelect = ({ detail: { blockId } }): void => {
    if (this.dataset.blockId === blockId) {
      this.show()
    }
  }

  _handleBlockDeselect = ({ detail: { blockId } }): void => {
    if (this.dataset.blockId === blockId) {
      this.hide()
    }
  }

  show = async (): Promise<void> => {
    await super.show()
    this.addListener(this.selectBtn('accept'), 'click', this.onAccept)
    this.addListener(this.selectBtn('decline'), 'click', this.onDecline)
    this.addListener(this.selectBtn('close'), 'click', this.onDecline)
  }

  hide = async (): Promise<void> => {
    this.removeListener(this.selectBtn('accept'), 'click', this.onAccept)
    this.removeListener(this.selectBtn('decline'), 'click', this.onDecline)
    this.removeListener(this.selectBtn('close'), 'click', this.onDecline)
    await super.hide()
  }

  onAccept = (): void => {
    if (this.isEditor) {
      this.hide()
      return
    }

    window.Shopify.customerPrivacy?.setTrackingConsent(true, this.hide)
  }

  onDecline = (): void => {
    if (this.isEditor) {
      this.hide()
      return
    }

    window.Shopify.customerPrivacy?.setTrackingConsent(false, this.hide)
  }

  selectBtn(type: 'accept' | 'decline' | 'close'): Nullable<HTMLElement> {
    if (!this.isOpen) {
      return null
    }

    return $el(`[data-${type}-btn]`, this)
  }
}
